import React, { Fragment, useEffect, useState } from "react";
import "@styles/tuneIn/css/style.scss";
import "@styles/tuneIn/css/flaticon.scss";
import "@styles/tuneIn/css/animate.scss";
import "@styles/tuneIn/css/dark_theme.scss";
import "@styles/tuneIn/css/font-awesome.scss";
import "@styles/tuneIn/css/fonts.css";
import "@styles/tuneIn/css/magnific-popup.scss";
import "@styles/tuneIn/css/nice-select.scss";
import "@styles/tuneIn/css/owl.carousel.scss";
import "@styles/tuneIn/css/owl.theme.default.scss";
import "@styles/tuneIn/css/responsive.scss";
import "@styles/tuneIn/css/swiper.scss";

import Login from "../TuneIn/Login";
import { Link } from "react-router-dom";
import { getWebsiteStyle } from "@store/action/smartend/SettingsAction";
import { useDispatch, useSelector } from "react-redux";
import { CardText } from "reactstrap";
import { Clock } from "react-feather";
import { SiAirplayaudio } from "react-icons/si";
import Widgets from "../TuneIn/widgets";
import IntlTuneIn from "../../@core/layouts/components/navbar/IntlTuneIn";
import { getMenus } from "@store/action/smartend/MenuAction";
import { useTranslation } from "react-i18next";
import {
  activeMenuDropdown,
  toggleNavBarLi,
  activeNavbar,
  animationBarOne,
  toggleNavBarLiFixed,
} from "@src/@core/components/tuneIn/main.js";
import { useIcecast } from "@hooks/useIcecast";

const Navbar = () => {
  const { icecastData } = useIcecast();
  const thisisAuth = localStorage.getItem("isAuth");
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const SettingsReducer = useSelector((state) => state.SettingsReducer).data;
  const MenuReducer = useSelector((state) => state.MenuReducer).data;
  const [timeNow, setValue] = useState(new Date());

  useEffect(() => {
    activeNavbar();
  }, [window.location.href]);
  useEffect(() => {
    toggleNavBarLiFixed();
  }, [$(window).width()]);
  useEffect(() => {
    toggleNavBarLi();
    dispatch(getWebsiteStyle());
    dispatch(getMenus({ per_page: 20 }));
  }, []);

  useEffect(() => {
    const interval = setInterval(() => setValue(new Date()), 1000);
    return () => {
      clearInterval(interval);
    };
  }, []);
  const listeners = icecastData?.listeners | 0;
  const goTop = (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
  };
  const url = window.location.pathname;
  const [active, setActive] = useState(url);
  const toggleActive = (tab) => {
    if (active !== tab) {
      setActive(tab);
    }
  };
  useEffect(() => {
    setActive(url);
  }, [url]);
  const [listArr1, setListArr1] = useState([]);
  const filtered_Menu = MenuReducer?.filter((el) => el.status === 1);
  useEffect(() => {
    setListArr1(filtered_Menu);
  }, [MenuReducer]);
  useEffect(() => {
    listArr1.length && activeMenuDropdown();
  }, [listArr1]);

  return SettingsReducer ? (
    <Fragment>
      <div className="go_top_tuneIn">
        <div onClick={goTop}>
          <i className="fa fa-arrow-up"></i>
        </div>
      </div>
      <div className="m24_main_wrapper">
        <div id="sidebar" className="index4_sidebar index3_sidebar">
          <div className="l-sidebar l2_sidebar">
            <div
              id="toggle_close4"
              onClick={() => {
                animationBarOne("0px");
              }}
            >
              ×
            </div>
            <div id="cssmenu">
              <Link to="/">
                <img
                  src={SettingsReducer.style_logo && SettingsReducer.style_logo}
                  style={{ width: "120px", height: "75px" }}
                  alt="logo"
                />
              </Link>
              <div className="my-auto" style={{ marginLeft: "29px" }}>
                <h6
                  style={{ color: `${SettingsReducer.style_color1}` }}
                  className="fw-bolder mb-0"
                >
                  {SettingsReducer.text_1}
                </h6>
                <CardText className="font-small-3 mb-0">
                  <span style={{ color: `${SettingsReducer.style_color2}` }}>
                    {SettingsReducer.text_2}
                  </span>
                </CardText>
              </div>

              <ul className="sidebb">
                {listArr1.map((item, i) => {
                  return item.children.length > 0 ? (
                    <li key={i} className="has-sub">
                      <a>
                        <i className={`${item.icon}`}></i>
                        {t(item.title)}
                      </a>
                      <ul>
                        {item.children.map((e, i) => {
                          return (
                            <li key={i}>
                              <Link
                                onClick={() => {
                                  toggleActive(`${e.link}`);
                                }}
                                to={`${e.link}`}
                                className={
                                  active.includes(`${e.link}`) ? "active" : ""
                                }
                              >
                                {t(e.title)}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    </li>
                  ) : (
                    <li key={i}>
                      <Link
                        onClick={() => {
                          toggleActive(`${item.link}`);
                        }}
                        className={active === `${item.link}` ? "active" : ""}
                        to={`${item.link}`}
                      >
                        <span>
                          <i className={`${item.icon}`}></i>
                          {t(item.title)}
                        </span>
                      </Link>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="navbar__template_4">
        <div className="">
          <div className="c-header-icon js-hamburger d-xl-none">
            <div
              className="hamburger-toggle"
              onClick={() => {
                animationBarOne("260px");
              }}
            >
              <i className="flaticon-menu-1"></i>
            </div>
          </div>
        </div>
        <div className="widg_aud">
          {/* <div className="m24_navigation_wrapper" style={{ float: "none" }}>
            <div className="mainmenu">
              <ul className="main_nav_ul">
                <li className="widget_navigation_bar0">
                  <a className="gc_main_navigation">
                    Widgets <i className="flaticon-down-arrow" />
                  </a>
                  <ul className="navi_2_dropdown">
                    <Widgets />
                  </ul>
                </li>
              </ul>
            </div>
          </div> */}
          <div className="nmbr_aud">
            <SiAirplayaudio
              className="clignoteAudience"
              size={18}
              style={{ marginTop: "-3px", marginRight: "3px" }}
            />
            <span>{t("Number of listeners")}:</span> {listeners}
          </div>
          <div className="date_now_4">
            <Clock
              size={18}
              style={{ marginTop: "-3px", marginRight: "3px" }}
            />
            {timeNow.toLocaleString()}
          </div>
        </div>
        <div className="language_dash">
          <div className="language_4">
            <div className="responsive_search_toggle">
              <a data-bs-toggle="modal" data-bs-target="#changeLangTuneIn">
                {t("languages")} <i className="fas fa-language" />
              </a>
            </div>
          </div>
          <div className="dashboard_4">
            {thisisAuth == "true" ? (
              <div className="">
                <Link className=" btn-outline" to="/admin/dashboard">
                  <span>{t("Dashboard")}</span>
                </Link>
              </div>
            ) : (
              <div className=" responsive_search_toggle">
                <a data-bs-toggle="modal" data-bs-target="#login_modal">
                  <div className="login_top_wrapper">
                    <p>login/register</p>
                  </div>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* language section*/}
      <IntlTuneIn />
      {/* login section */}
      <Login />
    </Fragment>
  ) : (
    ""
  );
};

export default Navbar;
